import requestProvider from "./axiosHandler";

const getAllProduction = () => {
    return requestProvider
        .get('/production/get-all')
};

const createAll = (list) => {
    return requestProvider
        .post('/production/create-all', list)
};

const createProduction = (list) => {
    return requestProvider
        .post('/production', list)
};

const updateProduction = (list) => {
    return requestProvider
        .put('/production', list)
};
const getProductionById = (id) => {
    return requestProvider
        .get(`/production/${id}`)
};

const deleteProduction = (id) => {
    return requestProvider
        .delete(`/production/${id}`)
};

const getCalendarProduction = () => {
    return requestProvider
        .get('/production/calender-content')
};

const changeClosedStatus = (list) => {
    return requestProvider
        .post(`/production/change-status`, list)
};

const getProductionStocks = (id) => {
    return requestProvider
        .get(`production/get-production-stocks/${id}`)
};

const getDetailById = (id) => {
    return requestProvider
        .get(`production/get-by-detail/${id}`)
};

const getProductionsWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/production?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 


export {getProductionStocks, getAllProduction, createProduction, createAll, deleteProduction,getDetailById, getProductionById, updateProduction, getCalendarProduction, changeClosedStatus, getProductionsWithPage}